import {Component, OnInit, OnDestroy, ChangeDetectionStrategy} from '@angular/core';
import {PermissionKeys} from '../../app.constants';
import {SurveyLightDto, SurveyService} from "../../_services/configuration-services";
import {filter, Subscription, take} from "rxjs";
import {TranslateUtils} from "../../_shared/translate-utils";
import {DateUtils} from "../../_shared/date-utils";
import {faPen} from "@fortawesome/free-solid-svg-icons";
import {LangChangeEvent, TranslateService} from "@ngx-translate/core";
import {BackofficePermissionsService} from "../../_shared/backoffice-permissions.service";
import {RolesService} from "../../_shared/roles-service";
import {Location} from '@angular/common';


@Component({
    selector: 'app-surveys',
    templateUrl: './surveys.component.html',
    styleUrls: ['./surveys.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SurveysComponent implements OnInit, OnDestroy {

    PermissionKeys = PermissionKeys;

    surveys: SurveyLightDto[] = [];

    private langChangeSubscription: Subscription;
    crtLang = TranslateUtils.defaultLanguage;

    // Formats
    formats = {
        date: DateUtils.dateFormat,
    };

    // Icons
    icons = {
        pen: faPen
    };

    constructor(private readonly surveyService: SurveyService,
                private readonly translateService: TranslateService,
                private readonly backofficePermissionsService: BackofficePermissionsService,
                private readonly rolesService: RolesService,
                private readonly location: Location) {
    }

    ngOnInit(): void {
        this.crtLang = this.translateService.currentLang;
        this.langChangeSubscription = this.translateService.onLangChange.subscribe((event: LangChangeEvent) => {
            this.crtLang = event.lang;
        });
        this.fetchSurveys();
    }

    private fetchSurveys(): void {
        // Client account: no backoffice permissions are ever loaded → fetch the self list directly.
        if (!this.rolesService.isBackofficeAccount()) {
            this.loadSurveys(false);
            return;
        }
        // Backoffice: wait until permissions are loaded before branching, otherwise a direct page
        // reload reads them as empty and wrongly falls back to the (empty) self list.
        this.backofficePermissionsService.permissionsLoaded$
            .pipe(filter(loaded => loaded), take(1))
            .subscribe(() => this.loadSurveys(
                this.backofficePermissionsService.hasPermission(PermissionKeys.gestionCommunication)));
    }

    private loadSurveys(canManage: boolean): void {
        if (canManage) {
            this.surveyService.getAll().pipe().subscribe(surveys => this.surveys = surveys,
                () => this.surveys = []);
        } else {
            this.surveyService.getAllActive().pipe().subscribe(surveys => this.surveys = surveys.sort((a, b) => a.order - b.order),
                () => this.surveys = []);
        }
    }

    ngOnDestroy(): void {
        this.langChangeSubscription.unsubscribe();
    }

    back(): void {
        this.location.back();
    }
}
